import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const INITIAL_VALUES = {};

const DataContext = createContext(INITIAL_VALUES);

const isJsonValue = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const DataProvider = props => {
  const { children, id, initial } = props;
  const [state, setState] = useState(initial || INITIAL_VALUES);
  const [userData, setUserData] = useState(null);
  // const [responses, setResponses] = useState([]);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log('on data context results');
    const getRespData = async () => {
      const POST_API = `/api/response`;
      const body = {
        params: {
          id
        }
      };
      // console.log('prev calling');
      // const options = { ...opts, headers };
      // console.log({ body, options });
      const { data } = await axios.get(POST_API, body);
      // console.log({ data });
      if (data) {
        try {
          const parsed = JSON.parse(data);
          const parsedData = parsed.data;
          const campaign = parsedData.campaign;
          if (parsedData.data) {
            parsedData.data = isJsonValue(parsed.data.data)
              ? JSON.parse(parsed.data.data)
              : parsed.data.data;
            if (campaign.metadata) {
              campaign.metadata = isJsonValue(parsed.data?.campaign?.metadata)
                ? JSON.parse(parsed.data?.campaign?.metadata)
                : parsed.data?.campaign?.metadata;
              // update initial parsedData campaign field
              parsedData.campaign = campaign;
            }
          }
          await setResponse(parsedData);
        } catch (err) {
          await setResponse(null);
        }
      }
      await setLoading(false);
    };
    getRespData();
  }, [id]);

  return (
    <DataContext.Provider
      value={{
        ...state,
        updateContext: setState,
        response,
        isLoading: loading,
        userData,
        setUserData
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const DataConsumer = DataContext.Consumer;
export const useDataContext = () => useContext(DataContext);
